import { render } from "./EventList.vue?vue&type=template&id=8b7f00ec&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=8b7f00ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8b7f00ec"

export default script